import axios, { Method } from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

let pendingDeletePin: string | null = null;

export const setPendingDeletePin = (pin: string | null) => {
  pendingDeletePin = pin;
};

let isRedirectingToLogin = false;

const handleAuthFailure = (message?: string) => {
  localStorage.removeItem("authToken");
  sessionStorage.removeItem("pinUnlocked");

  if (window.location.pathname !== "/" && !isRedirectingToLogin) {
    isRedirectingToLogin = true;

    if (message) {
      sessionStorage.setItem("authMessage", message);
    }

    window.location.replace("/");
  }
};

const request = (
  method: Method,
  url: string,
  options = { params: {}, payload: {}, headers: {} }
) => {
  const request = {
    url,
    method,
    params: options.params,
    data: options.payload,
    headers: options.headers,
  };

  return new Promise((resolve, reject) => {
    axios
      .request(request)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

/* REQUEST INTERCEPTOR */

axios.interceptors.request.use(async (request) => {
  const headers: any = {
    apikey: process.env.REACT_APP_API_KEY,
  };
  const token = await localStorage.getItem("authToken");

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  if (String(request.method).toUpperCase() === "DELETE" && pendingDeletePin) {
    headers["x-delete-pin"] = pendingDeletePin;
    pendingDeletePin = null;
  }

  request.headers = Object.assign(request.headers || {}, headers);

  return request;
});

/* RESPONSE INTERCEPTOR */

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.auth === false) {
      handleAuthFailure(error.response.data.message);
    }

    return error.response;
  }
);

export const GET = (path: string, params: any) => {
  return request("GET", path, {
    params,
    payload: {} as any,
    headers: {} as any,
  });
};

export const POST = (path: string, payload: any) => {
  return request("POST", path, {
    payload,
    params: {} as any,
    headers: {} as any,
  });
};

export const PUT = (path: string, payload: any) => {
  return request("PUT", path, {
    payload,
    params: {} as any,
    headers: {} as any,
  });
};

export const DELETE = (path: string, params: any = {} as any) => {
  return request("DELETE", path, {
    params,
    payload: {} as any,
    headers: {} as any,
  });
};

export const POSTFormData = (path: string, payload: any) => {
  return request("POST", path, {
    payload,
    params: {} as any,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const PUTFormData = (path: string, payload: any) => {
  return request("PUT", path, {
    payload,
    params: {} as any,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
